import { AssetDetail } from '@atom/types/asset';
import {
  AssetRequestsFilters,
  AssetRequestStatus,
  AssetRequestType,
} from '@atom/types/assetRequest';
import { isNilOrEmpty } from '@atom/utilities/validationUtilities';

import {
  INVENTORY_STATUS_OPTIONS,
  REPLENISHMENT_STATUS_OPTIONS,
} from '../assetRequestConstants';

const ADOT_STATUS_OPTIONS = {
  [AssetRequestType.ADOT_INVENTORY_TRANSFER]: INVENTORY_STATUS_OPTIONS,
  [AssetRequestType.ADOT_REPLENISHMENT]: REPLENISHMENT_STATUS_OPTIONS,
};

export const getADOTStatusOptions = (
  type: AssetRequestType,
): AssetRequestStatus[] => {
  return ADOT_STATUS_OPTIONS[type] || [];
};

export const getADOTTypeChangeFilters = (
  type: AssetRequestType,
  asset?: AssetDetail,
): AssetRequestsFilters => {
  if (isNilOrEmpty(asset)) {
    return { type };
  }

  const isTransfer = type === AssetRequestType.ADOT_INVENTORY_TRANSFER;

  return {
    type,
    assetId: asset?.id,
    ...(isTransfer && {
      fromAssetId: asset?.id,
    }),
  };
};
